import { render, staticRenderFns } from "./FormRequest.vue?vue&type=template&id=1a73c6b1&scoped=true&"
import script from "./FormRequest.vue?vue&type=script&lang=js&"
export * from "./FormRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a73c6b1",
  null
  
)

export default component.exports